var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomMarketplace = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.04 11.707V26a.4.4 0 0 1-.4.4h-13.4v-8.642a.4.4 0 0 0-.4-.4H6.752a.4.4 0 0 0-.4.4V26.4H4.36a.4.4 0 0 1-.4-.4V11.707h22.08zm-4.095 4.856h-5.2a.4.4 0 0 0-.4.4v5.2c0 .22.179.4.4.4h5.2a.4.4 0 0 0 .4-.4v-5.2a.4.4 0 0 0-.4-.4z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.252 6.998h21.496a.4.4 0 0 1 .38.278l2.506 7.865a.4.4 0 0 1-.381.522H1.747a.4.4 0 0 1-.38-.522L3.87 7.276a.4.4 0 0 1 .381-.278z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36 3.6h21.28c.22 0 .4.18.4.4v1.76H3.96V4c0-.22.18-.4.4-.4z",
    fill: "#1B7690"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomMarketplace);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-marketplace.9a211a2caef3b057715230e4ee19df1c.svg";